export interface AdvancedColor {
  isActive?: boolean;
  primary?: string;
  secondary?: string;
  shadow1?: string;
  shadow3?: string;
}

export interface Tab {
  type: string;
  source?: string;
  authId?: string;
  order?: number;
}

export interface Link {
  _id: string;
  [key: string]: unknown;
}

export interface LinkIcon {
  _id: string;
  [key: string]: unknown;
}

export interface PersonaInfo {
  [key: string]: unknown;
}

export interface ProfileMainTabsProps {
  username?: string;
  userId?: string;
  userBlockHeight?: number;
  auths?: Array<{ _id: string; [key: string]: unknown }>;
  isMe: boolean;
  isPreview?: boolean;
  isOnboarding?: boolean;
  colorMode?: string;
  advancedColor?: AdvancedColor | null;
  tabs?: Tab[];
  links?: Link[];
  linkIcons?: LinkIcon[];
  isLoggedIn?: boolean;
  personaInfo?: PersonaInfo;
}

export const ICON_NAME_MAP: Record<string, string> = {
  links: 'Link1',
  nft: 'Nft',
  subscribe: 'Subscribe',
  donate: 'Donations',
  persona: 'Info',
  product: 'ShoppingBag',
};
